<template>
  <a-table
    id="tableDataTabs"
    :columns="columns"
    :dataSource="data"
    :pagination="false"
    bordered> </a-table>
</template>
<script>
import { getAssetHistrDepreciate } from '@/api/assetLedger'

export default {
  props: {
    model: Object
  },
  data () {
    return {
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return index + 1
          },
          width: 50
        },
        {
          title: '会计年度',
          dataIndex: 'gjahr',
          align: 'center'
        },
        {
          title: '当期资产价值',
          dataIndex: 'zcjz',
          align: 'center'
        },
        {
          title: '当期折旧',
          dataIndex: 'dqzj',
          align: 'center'
        },
        {
          title: '累计折旧',
          dataIndex: 'ljzj',
          align: 'center'
        },
        {
          title: '期末价值',
          dataIndex: 'dqjz',
          align: 'center'
        }
      ],
      data: []
    }
  },
  watch: {
    model: {
      handler (model) {
        if (model) this.initValueDetail()
      },
      immediate: true
    }
  },
  methods: {
    initValueDetail () {
      const { model } = this
      const params = {
        anln1: '00' + model.anln1,
        bukrs: model.bukrs
      }
      getAssetHistrDepreciate(params).then(res => {
        if (res.status === 0) {
          this.data = res.data
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-thead > tr > th {
  background: #E7F4FF !important;
  padding: 10px !important;
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px !important;
}
/deep/.ant-table-placeholder {
  position: relative !important;
}
#tableDataTabs  {
  /deep/.ant-spin-nested-loading {
    >.ant-spin-container {
      .ant-table-bordered {
        .ant-table-header > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-thead > tr > th{
          border-right: 1px solid #e8e8e8;
        }
        .ant-table-body > table{
          border-top: 1px solid #e8e8e8;
          border-left: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr > td{
          border-right: 1px solid #e8e8e8;
          border-bottom: 1px solid #e8e8e8;
        }
        .ant-table-tbody > tr.ant-table-row-selected td{
          background-color: rgba(225, 225, 225, 0);
        }
        .ant-table-footer{
          border: none !important;
        }
      }
    }
  }
}
</style>
